import React from 'react';
import { CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, } from '@material-ui/core';
class PrintOptionDialog extends React.Component {
    state = { fields: {} };

    handleChange = (event) => {
        let fields = this.state.fields;
        const name = event.target.name;
        const value = event.target.value;
        fields[name] = value;
        this.setState({ fields });
    }

    componentDidMount() {
        const { cy } = this.props;
        if (cy) {
            let fields = this.state.fields;
            fields.cy = cy;
            this.setState({ fields });
        }
    }
    render() {
        const { open, handleClose, handleSubmit, data, branch, saving } = this.props;
        const { fields } = this.state;
        return (
            <Dialog open={open} 
                // onClose={handleClose} aria-labelledby="form-dialog-title" 
            >
                <DialogTitle id="form-dialog-title">Choose CY</DialogTitle>
                <DialogContent dividers>
                    <label>
                        <Typography variant="caption" >Branch: {branch ? branch.branchName : ''}</Typography>
                    </label>
                    <br />
                    <label>
                        <Typography variant="caption" >CY</Typography><br />
                        <select required value={fields.cy ? fields.cy : ''} name="cy" onChange={this.handleChange} style={{ width: 320 }}>
                            <option value="">Select CY</option>
                            {
                                data && data.length > 0 ?
                                    data.map((d, id) => (<option key={id} value={d.code}>{d.name}</option>))
                                : null
                            }
                        </select>
                    </label>
                </DialogContent>
                {saving ?
                <DialogActions>
                    <Button disabled size='small'><CircularProgress size={25} style={{ marginRight: 8 }} /> Saving...</Button>
                </DialogActions> :
                <DialogActions>
                    <Button onClick={handleClose} color="default" size='small'>cancel</Button>
                    <Button onClick={() => handleSubmit(fields)} color="primary" size='small' autoFocus>submit</Button>
                </DialogActions>}
            </Dialog>
        )
    }
}
export default PrintOptionDialog